import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import { callUploadFile, callAddAppControls, callEditAppControls, callGetAppControlsById } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import { displayUrl, decodeBase64, handleGetCookie, convertStringToJson } from "../../../utils/commonUtil";
import { toast } from "react-toastify";
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./style.css"
import colors from '../../../utils/colors'
import appTypeList from "../../../data/appTypeList"
import DatePicker from "react-datepicker";
import FileUploadGrid from "../../../components/upload-file";
import moment from "moment";

const MAX_IMAGES_PER_ROW = 4;

const Index = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	let params = useParams();
	const { t } = useTranslation();
	const [appControl, setAppControl] = useState({
		title: '', documentPath: null, appType: '', priority: 1, carriredCode: null, carriredName: null, id: null, startDate: "", endDate: ''
	});
	const [images, setImages] = useState([]);
	const [selectedImage, setSelectedImage] = useState(null);
	const fileInputRef = useRef(null);
	const [display, setDisplay] = useState([]);

	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				setAppControl((prev) => ({
					...prev, id
				}));
				intialData(id)
			}
		}
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setAppControl((prev) => ({
				...prev,
				carriredCode: authData?.user?.userId,
				carriredName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			}));
		}
	}, []);

	const intialData = async (id) => {
		const res = await dispatch(callGetAppControlsById({ id }))
		if (res?.payload?.responseCode === "00000") {
			let data = res?.payload?.data
			setAppControl((prev) => ({
				...prev,
				title: data?.title,
				appType: data?.appType,
				priority: data?.priority,
				documentPath: data?.documentPath ? convertStringToJson(data?.documentPath) : [],
				startDate: data?.startDate,
				endDate: data?.endDate
			}));
		}
	}

	const handleImageSelect = (e) => {
		setSelectedImage({ file: e });
	};


	const handleChange = (e) => {
		const { name, value } = e.target;
		setAppControl({
			...appControl,
			[name]: value,
		});
	};

	const cancelAddImage = (e) => {
		e.preventDefault()
		setSelectedImage(null);
		setAppControl((prev) => ({
			...prev,
			documentPath: null,
		}));
	};

	const triggerFileInput = () => {
		fileInputRef.current.click();
	};

	const handleSave = async (e) => {
		e.preventDefault()
		console.log("appControl", appControl)
		try {
			Swal.fire({
				title: t("titleSave"),
				text: t("confirmSave"),
				icon: "warning",
				reverseButtons: true,
				showCancelButton: true,
				confirmButtonColor: colors.confirmMessage,
				cancelButtonColor: colors.cancel,
				confirmButtonText: t('confirm'),
				cancelButtonText: t('cancel')
			}).then(async (result) => {
				if (result.isConfirmed) {
					try {
						let docPath = null
						let req = {
							title: appControl.title,
							appType: appControl.appType,
							carriredCode: appControl.carriredCode,
							carriredName: appControl.carriredName,
							priority: appControl.priority,
							id: appControl.id,
							startDate: appControl.startDate,
							endDate: appControl.endDate
						}
						let res = null

						if (appControl.id == null) {
							if (appControl.documentPath == null) {
								const upload = await dispatch(callUploadFile(selectedImage.file));
								if (upload?.payload?.responseCode === "00000") {
									docPath = JSON.stringify(upload?.payload?.data)
								}
							}
							if(docPath == null){
								toast.error(t("pleaseSelectFileBeforeUpload"), { position: "top-left" })
								return
							}
							req.documentPath = docPath
							res = await dispatch(callAddAppControls(req));
						} else {
							if (appControl.documentPath == null) {
								if (selectedImage === null) {
									toast.error(t("pleaseSelectFileBeforeUpload"), { position: "top-left" })
									return
								}
								console.log("uploading file...")
								if (selectedImage !== null) {
									const upload = await dispatch(callUploadFile(selectedImage.file));
									if (upload?.payload?.responseCode === "00000") {
										docPath = JSON.stringify(upload?.payload?.data)
									}
								}
							}
							req.documentPath = (docPath == null ? JSON.stringify(appControl.documentPath) : docPath)
							res = await dispatch(callEditAppControls(req));
						}

						if (res?.payload?.responseCode === "00000") {
							Swal.fire({
								icon: "success",
								title: t("success.add"),
								confirmButtonColor: colors.confirmMessage,
								confirmButtonText: t('close'),
							}).then(function () {
								notifyListRefresh();
								navigate(-1);
							});
						} else {
							toast.error(res?.payload?.responseCode + " - " + res?.payload?.responseDescription, {
								position: "top-left"
							})
						}
					} catch (error) {
						Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
					}
				}
			});
		} catch (error) {
			console.error("error: ", error)
		}
	}

	const selectAppType = (e) => {
		setAppControl((prev) => ({
			...prev,
			appType: e.target.value,
		}));
	}

	const selectPriority = (e) => {
		setAppControl((prev) => ({
			...prev,
			priority: e.target.value,
		}));
	}

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave} autoComplete="off">
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{t("settings.appControl.add")}</h4>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="row">
										<div className="col-12">
											<h5>{display?.pro_name_lo}</h5>
										</div>
									</div>
									<div className="default-form">
										<div className="row">
											<div className="col-md-6 form-group">
												<label> {t('settings.appControl.title')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="title"
													className="form-control-uld"
													placeholder={t('settings.appControl.title')}
													onChange={handleChange}
													value={appControl.title}
													autoComplete="off"
													required />
											</div>
											<div className="col-md-6 form-group">
												<label> {t('settings.appControl.appType')}<span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													onChange={selectAppType}
													value={appControl.appType}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														appTypeList.map((item) => (
															<option key={item.id} value={item.key}>{t(item.name)}</option>
														))
													}
												</select>
											</div>
											<div className="col-md-4 form-group">
												<label>{t('startDate')}</label>
												<DatePicker
													selected={appControl.startDate}
													onChange={date => setAppControl((prev) => ({
														...prev,
														startDate: moment(date).format('YYYY-MM-DD'),
													}))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('startDate')}
													className="form-control-uld"
												/>
											</div>

											<div className="col-md-4 form-group">
												<label>{t('endDate')}</label>
												<DatePicker
													selected={appControl.endDate}
													onChange={date => setAppControl((prev) => ({
														...prev,
														endDate: moment(date).format('YYYY-MM-DD'),
													}))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('endDate')}
													className="form-control-uld"
												/>
											</div>
											<div className="col-md-4 form-group">
												<label> {t('settings.appControl.priority')}<span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													onChange={selectPriority}
													value={appControl.priority}
													required
												>
													{
														Array.from({ length: 10 }, (_, i) => (
															<option key={i + 1} value={i + 1}>{i + 1}</option>
														))
													}
												</select>
											</div>
											<div className="col-12 col-md-12 form-group">
												<label> {t('settings.appControl.img')}<span className="text-danger">*</span> </label>
												<FileUploadGrid
													multiple={false}
													folderName="app_control"
													filesFromApi={appControl.documentPath || []}
													onChange={handleImageSelect}
													accept="image/*"
													required
												/>
											</div>
										</div>
									</div>

									<div className="col-12 d-flex justify-content-center">
										<div className="m-3">
											<button className="theme-btn btn-style-one w-100" type="submit">
												<i className="fas fa-add"></i>&nbsp;{t("button.save")}
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
